import {
  keepPreviousData,
  queryOptions,
  skipToken,
} from '@tanstack/react-query';

import type { InventoryProductResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const inventoryProductKeys = {
  all: () => ['inventoryProducts'] as const,
  detail: (props: { url: string }) =>
    [...inventoryProductKeys.all(), 'detail', props.url] as const,
};

export const inventoryProductQueries = {
  detail: (props: { url: string }) =>
    queryOptions({
      queryKey: inventoryProductKeys.detail(props),
      queryFn: props.url
        ? () =>
            HttpClient.request<InventoryProductResponseData>({
              method: 'GET',
              url: props.url,
            })
        : skipToken,
      refetchOnWindowFocus: true,
      placeholderData: keepPreviousData,
    }),
};
